import { ITrajectoryCoordinate, IReportVideo } from 'Data';
import { observable } from 'mobx';

export class IReportMeasurement {
  id?: string;
  time?: Date;
  club?: string;
  tags?: Array<string>;
  videos?: Array<IReportVideo>;
  ball?: string;
  playerDexterity?: string;
  attackAngle?: number;
  launchDirection?: number;
  ballSpeed?: number;
  clubPath?: number;
  clubSpeed?: number;
  dynamicLoft?: number;
  faceAngle?: number;
  faceToPath?: number;
  launchAngle?: number;
  smashFactor?: number;
  spinAxis?: number;
  spinLoft?: number;
  spinRate?: number;
  swingDirection?: number;
  swingPlane?: number;
  swingRadius?: number;
  dPlaneTilt?: number;
  height?: number;
  carry?: number;
  total?: number;
  side?: number;
  sideTotal?: number;
  landingAngle?: number;
  hangTime?: number;
  lastData?: number;
  lowPointDistance?: number;
  distanceToPin?: number;
  distanceToTarget?: number;
  score?: number;
  distanceScore?: number;
  directionScore?: number;
  effectiveStimp?: number;
  speedDrop?: number;
  rollPercentage?: number;
  rollSpeed?: number;
  skidDistance?: number;
  totalBreak?: number;
  optimizeOn?: boolean;
  uploadOn?: boolean;
  canOptimize?: boolean;
  @observable isVisible?: boolean;
  hasVideos?: boolean;
  trajectory?: Array<ITrajectoryCoordinate>;
  impactHeight?: number;
  impactOffset?: number;
  backswingTime?: number;
  forwardswingTime?: number;
  tempo?: number;
  strokeLength?: number;
  dynamicLie?: number;
  curve?: number;
  spinIndex?: number;
  smashIndex?: number;
  ballSpeedDifference?: number;
  spinRateDifference?: number;
}
